const Logo = (props) => {
  let imgURL = '/static/solarfluxLogo.png';

  if (window.screen.availWidth < 576) {
    imgURL = '/static/solarfluxLogo_small.png';
  }

  return (
    <img
      alt="Logo"
      src={imgURL}
      height="60px"
      {...props}
    />
  );
};

export default Logo;
